import React, { Component } from 'react';
import { Tabs, Input /**, AutoComplete */, ConfigProvider } from 'antd';
// const { Option } = AutoComplete;
import withAriaTabs from '../../Aria/AriaTab';
import zhCN from 'antd/es/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import './Shared.scss';
const { TabPane } = Tabs;
const AriaTabs = withAriaTabs(Tabs);
import ShareTabTitle from './SharedTable';
import intl from 'react-intl-universal';
import { getQueryVariable } from '@/utils/utils';
import { store } from 'Store/store.index';
import { storageService } from '@/store/services/index';
import { isSharedClound } from '@/api/index';
// import ShareEmpty from './ShareEmpty';
import { inject, observer } from 'mobx-react';
moment.locale('zh-cn');
@inject('appStore', 'userStore', 'accountStore', 'historyStore')
@observer
class Shared extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 'yours',
      // viewModel: 'list',
      shareTabList: [
        {
          title: '我发起的',
          content: () => {
            return (
              <React.Fragment>
                {this.state.type === 'yours' && (
                  <ShareTabTitle
                    type="yours"
                    getShareList={this.getShareList}
                    searchWord={this.state.searchWord}
                    setListFunc={this.setListFunc}
                    parentCom="Home"
                    supportConvertDocumentSuffixs={this.props.supportConvertDocumentSuffixs}
                    isDisabledDragFileOpen={this.props.isDisabledDragFileOpen}
                    onDrop={this.props.onDrop}
                    openFile={this.props.openFile}
                  />
                )}
              </React.Fragment>
            );
          },
        },
        {
          title: '我收到的',
          content: () => {
            return (
              <React.Fragment>
                {this.state.type === 'others' && (
                  <ShareTabTitle
                    type="others"
                    getShareList={this.getShareList}
                    searchWord={this.state.searchWord}
                    setListFunc={this.setListFunc}
                    supportConvertDocumentSuffixs={this.props.supportConvertDocumentSuffixs}
                    doInitializePDFViewerUI={this.props.doInitializePDFViewerUI}
                    isDisabledDragFileOpen={this.props.isDisabledDragFileOpen}
                    onDrop={this.props.onDrop}
                    openFile={this.props.openFile}
                  />
                )}
              </React.Fragment>
            );
          },
        },
      ],
      options: [],
      searchWord: '',
      getListFunc: undefined,
      sharedTableSearchHistory: [],
      isShowSearchHistory: false,
      emptyList: false,
    };
  }
  getShareList = (data) => {
    if (data && data.list) {
      const isEmptyList = data.list.length == 0;
      store.collaborationStore.updateEmptyList(isEmptyList);
    }
  };

  componentDidMount() {
    store.collaborationStore.setShareListParams({});
    this.updateSharedTableSearchHistory();
  }
  componentWillUnmount() {
    this.setState = () => {
      return;
    };
    store.collaborationStore.setShareListParams({});
  }
  updateSharedTableSearchHistory = () => {
    const sharedTableSearchHistory = storageService.getSharedTableSearchHistory();

    this.setState({
      sharedTableSearchHistory,
    });
  };
  onBlurSearchComponent = () => {
    this.setState({
      isShowSearchHistory: false,
    });
  };
  onFocusSearchComponent = () => {
    this.setState({
      isShowSearchHistory: true,
    });
  };
  setListFunc = (getListFunc) => {
    this.setState({ getListFunc });
  };
  getTabPane = () => {
    return this.state.shareTabList.map((item, index) => {
      return (
        <TabPane tab={item.title} key={index}>
          {item.content()}
        </TabPane>
      );
    });
  };
  tabChange = (activeKey) => {
    const type = activeKey === '1' ? 'others' : 'yours';
    this.setState({ type });
    store.collaborationStore.changeTab(activeKey);
  };
  onAction = () => {
    if (this.state.getListFunc !== undefined) {
      this.setState({
        isShowSearchHistory: false,
      });
      this.state.getListFunc('init');
      storageService.updateSharedTableSearchHistory(this.state.searchWord);
      this.updateSharedTableSearchHistory();
    }
  };
  onSearchWithHistory(searchWord) {
    this.setState(
      {
        searchWord,
      },
      () => {
        this.onAction();
      },
    );
  }
  onChange = (e) => {
    let val = e.target.value;
    const { isEmptyList } = store.collaborationStore;
    this.setState({ searchWord: val });
    if (!val && isEmptyList) {
      store.collaborationStore.updateEmptyList(false);
      this.onAction();
    }
    if (e.nativeEvent.type === 'click') {
      this.onAction();
    }
  };
  onClickSearchIcon = () => {
    this.onAction();
  };
  onClearSearchHistory = () => {
    storageService.clearSharedTableSearchHistory();
    this.setState({
      // searchWord: '',
      sharedTableSearchHistory: [],
    });
  };
  getSearchComponent = () => {
    const { searchWord } = this.state;
    const SearchComponent = (
      <Input
        prefix={<i className="searchBoxIcon" onClick={this.onClickSearchIcon} />}
        className="searchBtnItem"
        value={searchWord}
        onChange={this.onChange}
        onPressEnter={this.onAction}
        onFocus={this.onFocusSearchComponent}
        onBlur={this.onBlurSearchComponent}
        allowClear
        placeholder={intl.get('collaboration.sharedList.searchDocuments')}
      />
    );
    return SearchComponent;
  };
  toEuInstance = () => {
    const { onlineEUUrl } = store.appStore;
    window.open(onlineEUUrl);
  };
  toCaInstance = () => {
    const { onlineCAUrl } = store.appStore;
    window.open(onlineCAUrl);
  };
  render() {
    // if (!store.userStore.userInfo) {
    //   return null
    // }

    // const { isEmptyList } = store.collaborationStore;
    let shareListType = getQueryVariable('shareListType') || '0';
    let isBlack = getQueryVariable('isBlack') == 1;
    let blackClassName = isBlack ? 'blackContainer' : '';
    const downloadClassName = isSharedClound() ? 'downloadContainer' : '';
    const { lang } = store.appStore.lng;

    shareListType = shareListType == 1 ? '1' : '0';
    return (
      <ConfigProvider locale={zhCN}>
        <div className={`shared ${blackClassName} ${downloadClassName} ${lang}`}>
          <div className="wrapper">
            <div className="list-header">
              {/* {(!isEmptyList || !!this.state.searchWord) && ( */}
                <div className="searchBtnBox">
                 {this.getSearchComponent()}
                </div>
              {/* )} */}
            </div>
            <AriaTabs defaultActiveKey={shareListType} onChange={this.tabChange}>
              {this.getTabPane()}
            </AriaTabs>
          </div>
        </div>
      </ConfigProvider>
    );
  }
}
export default Shared;
